import { render, staticRenderFns } from "./QuoteEmailAttachments.vue?vue&type=template&id=3428c984"
import script from "./QuoteEmailAttachments.vue?vue&type=script&lang=js"
export * from "./QuoteEmailAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3428c984')) {
      api.createRecord('3428c984', component.options)
    } else {
      api.reload('3428c984', component.options)
    }
    module.hot.accept("./QuoteEmailAttachments.vue?vue&type=template&id=3428c984", function () {
      api.rerender('3428c984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteEmailAttachments.vue"
export default component.exports